import React from "react";

import styles from "./styles.module.scss";

const ShadowBlock = ({ children }) => {
    return <div className={styles.block}>{children}</div>;
};

export default ShadowBlock;
